import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { IconPause as u, IconPlay as c } from "@rei/cedar";
import { openBlock as s, createElementBlock as n, normalizeStyle as g, normalizeClass as _, createElementVNode as h, Fragment as p, renderList as y, createBlock as m, KeepAlive as S, resolveDynamicComponent as P, createCommentVNode as V, renderSlot as M } from "vue";
const C = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [l, a] of t)
    o[l] = a;
  return o;
};
let b = 0;
const f = {
  pause: "Pause video",
  play: "Play video"
}, E = {
  name: "VideoPlayer",
  components: {
    IconPause: u,
    IconPlay: c
  },
  props: {
    src: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    poster: {
      type: String,
      required: !1,
      default: ""
    },
    tracks: {
      type: Array,
      required: !1,
      default: () => []
    },
    reduceMotion: {
      type: Boolean,
      required: !1,
      default: !1
    },
    autoPlay: {
      type: Boolean,
      required: !1,
      default: !0
    },
    ratio: {
      type: String,
      required: !1,
      default: "16-9"
    },
    lazy: {
      type: Boolean,
      required: !1,
      default: !0
    },
    hideControls: {
      type: Boolean,
      required: !1,
      default: !1
    },
    cover: {
      type: Boolean,
      required: !1,
      default: !1
    },
    buttonLabels: {
      type: Object,
      required: !1,
      default: () => f
    }
  },
  data() {
    return b += 1, {
      isPlaying: null,
      // Video playing state
      observer: null,
      // Lazy load observer
      videoSrc: [],
      // List of video source files paths
      posterSrc: "",
      // When needed will populate the poster video attribute
      mediaQuery: null,
      // Use to listen the media query settings to reduce motion
      isMotionActive: !1,
      // Reduce motion state
      ratioRgx: /^(?:\d+)(?:-)(?:\d+)/gm,
      // Aspect Ratio Regular expression
      componentId: `ambientVideo-${b}`
      // Generate the component ID
    };
  },
  computed: {
    shouldAutoPlay() {
      return !this.computedReduceMotion && this.autoPlay;
    },
    playButtonIcon() {
      return this.isPlaying ? u : c;
    },
    playButtonLabel() {
      const e = {
        ...f,
        ...this.buttonLabels
      };
      return this.isPlaying ? e.pause : e.play;
    },
    ratioCssVariable() {
      const e = this.ratioRgx.test(this.ratio) ? this.ratio : "16-9";
      if (!this.cover) {
        const [t, o] = e.split("-");
        return `--ambient-video-ratio: ${parseInt(o, 10) / parseInt(t, 10)};`;
      }
      return "";
    },
    computedReduceMotion() {
      return this.isMotionActive || this.reduceMotion;
    },
    isVideoSrcValid() {
      return this.videoSrc && this.videoSrc.length > 0;
    },
    renderControls() {
      return this.isVideoSrcValid && !this.hideControls;
    },
    wrapperClasses() {
      return {
        "ambient-video": !0,
        "ambient-video--cover": this.cover,
        "ambient-video--ready": this.isVideoSrcValid || this.posterSrc
      };
    }
  },
  watch: {
    reduceMotion() {
      this.reduceMotion ? this.pause() : this.play();
    },
    videoSrc(e) {
      (!e || e.length === 0) && (this.posterSrc = this.poster);
    },
    mediaQuery(e) {
      this.handleQueryChange(e);
    }
  },
  mounted() {
    this.checkReduceMotionSettings();
    const e = window && "IntersectionObserver" in window;
    this.lazy && e ? (this.observer = new IntersectionObserver(this.onElementObserve, {
      rootMargin: "10px 0px"
    }), this.observer.observe(this.$el)) : this.setVideoSrc();
  },
  beforeDestroy() {
    this.lazy && this.observer.disconnect();
  },
  methods: {
    /* c8 ignore start */
    play() {
      this.$refs.videoEl.play();
    },
    pause() {
      this.$refs.videoEl.pause();
    },
    togglePlay() {
      this.isPlaying ? this.pause() : this.play();
    },
    onVideoPlaying() {
      this.isPlaying = !0, this.$emit("update:reduceMotion", !1);
    },
    onVideoPause() {
      this.isPlaying = !1, this.$emit("update:reduceMotion", !0);
    },
    onElementObserve(e) {
      e.forEach(({
        target: t,
        isIntersecting: o
      }) => {
        o && (this.observer.unobserve(t), this.setVideoSrc());
      });
    },
    setVideoSrc() {
      this.videoSrc = this.src && Object.keys(this.src).reduce((e, t) => (this.src[t] && this.src[t].match(/\.(mp4|webm)$/) && e.push({
        src: `${this.src[t]}#t=0.001`,
        // #t=xx fixes safari render issue when autoPlay is false
        type: t === "webm" ? "video/webm" : "video/mp4"
      }), e), []);
    },
    setMotionState(e) {
      this.isMotionActive = e;
    },
    checkReduceMotionSettings() {
      var e;
      this.mediaQuery = (e = window == null ? void 0 : window.matchMedia("(prefers-reduced-motion: reduce)")) == null ? void 0 : e.matches, this.mediaQuery && this.setMotionState(this.mediaQuery);
    },
    handleQueryChange(e) {
      this.setMotionState(e);
    },
    onSourceError(e, t) {
      this.posterSrc = this.poster, this.$emit("source-error", new Error("ERROR_LOADING_SOURCE", {
        type: t
      }));
    }
    /* c8 ignore end */
  }
}, w = ["id", "autoplay", "poster"], B = ["src", "type", "onError"], I = ["src", "srclang", "label"], R = {
  key: 0,
  class: "ambient-video__controls"
}, k = ["title", "aria-label", "aria-controls"];
function O(e, t, o, l, a, r) {
  return s(), n("div", {
    style: g(r.ratioCssVariable),
    class: _(r.wrapperClasses)
  }, [h("video", {
    id: a.componentId,
    ref: "videoEl",
    autoplay: r.shouldAutoPlay,
    poster: a.posterSrc,
    preload: "metadata",
    playsinline: "true",
    muted: "true",
    loop: "true",
    "aria-hidden": "true",
    class: "ambient-video__player",
    onPlaying: t[0] || (t[0] = (...i) => r.onVideoPlaying && r.onVideoPlaying(...i)),
    onPause: t[1] || (t[1] = (...i) => r.onVideoPause && r.onVideoPause(...i))
  }, [(s(!0), n(p, null, y(a.videoSrc, (i, d) => (s(), n("source", {
    key: `source-${d}`,
    src: i.src,
    type: i.type,
    onError: (v) => r.onSourceError(v, i.type)
  }, null, 40, B))), 128)), (s(!0), n(p, null, y(o.tracks, (i, d) => (s(), n("track", {
    key: `track-${d}`,
    src: i.src,
    srclang: i.lang,
    label: i.label,
    kind: "subtitles"
  }, null, 8, I))), 128))], 40, w), r.renderControls ? (s(), n("div", R, [h("button", {
    title: r.playButtonLabel,
    "aria-label": r.playButtonLabel,
    "aria-controls": a.componentId,
    class: "ambient-video__controls-button",
    type: "button",
    onClick: t[2] || (t[2] = (...i) => r.togglePlay && r.togglePlay(...i))
  }, [(s(), m(S, null, [(s(), m(P(r.playButtonIcon), {
    class: "ambient-video__button-icon"
  }))], 1024))], 8, k)])) : V("", !0), M(e.$slots, "content", {}, void 0, !0)], 6);
}
const Q = /* @__PURE__ */ C(E, [["render", O], ["__scopeId", "data-v-b1b933d5"]]);
export {
  Q as default
};
